import memoized from '../memoized';

export const MinFactory = memoized((min, message) => value =>
  value.trim().length >= min ? undefined : message || true,
);
export const MaxFactory = memoized((max, message) => value =>
  value.trim().length <= max ? undefined : message || true,
);
